const settings = {
	title: "Settings",
	locale: "Locale",
	rows_per_page: "Rows per page",
};
export default settings;